export default __webpack_public_path__ + "static/media/logo.a66fcda6.png";